import { render, staticRenderFns } from "./OffersArchive.vue?vue&type=template&id=1f7ebaac&scoped=true"
import script from "./OffersArchive.vue?vue&type=script&lang=js"
export * from "./OffersArchive.vue?vue&type=script&lang=js"
import style0 from "./OffersArchive.vue?vue&type=style&index=0&id=1f7ebaac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7ebaac",
  null
  
)

export default component.exports